import { render, staticRenderFns } from "./FormularioTipoListaPrecio.vue?vue&type=template&id=73dafc81"
import script from "./FormularioTipoListaPrecio.vue?vue&type=script&lang=js"
export * from "./FormularioTipoListaPrecio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports